export default {
  SET_CURRENT_DATE: 'SET_CURRENT_DATE',
  SERVICE_CREATE_EVENT: 'SERVICE_CREATE_EVENT',
  CREATE_EVENT: 'CREATE_EVENT',
  SHOW_MANAGE_EVENT_MODAL: 'SHOW_MANAGE_EVENT_MODAL',
  HIDE_MANAGE_EVENT_MODAL: 'HIDE_MANAGE_EVENT_MODAL',
  SERVICE_REMOVE_EVENTS_FOR_DAY: 'SERVICE_REMOVE_EVENTS_FOR_DAY',
  SET_EVENTS: 'SET_EVENTS',
  REMOVE_EVENTS: 'REMOVE_EVENTS',
  SERVICE_REMOVE_EVENT: 'SERVICE_REMOVE_EVENT',
  SERVICE_UPDATE_EVENT: 'SERVICE_UPDATE_EVENT',
  UPDATE_EVENT: 'UPDATE_EVENT'
};